import { defaulted, record, string, boolean, type } from 'superstruct';
export const Sale = defaulted(type({
    enabled: boolean(),
    suffix: string(),
    cartMessage: defaulted(string(), ''),
    cartMessageAlwaysEnabled: boolean(),
    saleReturnProduct: boolean(),
    variantsMap: record(string(), boolean())
}), {
    enabled: false,
    suffix: '',
    cartMessage: '',
    cartMessageAlwaysEnabled: true,
    saleReturnProduct: false,
    variantsMap: {}
});
// Reusable defaults (frozen to avoid accidental mutation)
export const SALE_DEFAULTS = Object.freeze({
    enabled: false,
    suffix: '',
    cartMessage: '',
    cartMessageAlwaysEnabled: true,
    saleReturnProduct: false,
    variantsMap: {}
});
